import React from 'react';

export default function ThirdPartyDataProcessors() {
  return (
    <div className="bg-white text-gray-800 min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto space-y-10">
        <h1 className="text-3xl text-center font-bold text-purple-600">Third-Party Data Processors Disclosure</h1>

        <p className="text-gray-700">
          Million2Trillion (M2T) may utilize trusted third-party service providers to deliver certain platform functionalities, process transactions, and ensure secure operations.
        </p>

        <div>
          <h2 className="text-2xl font-semibold text-purple-500">What is a Data Processor?</h2>
          <p className="text-gray-700">
            A data processor refers to any external vendor or service used by M2T who may temporarily access or store user data solely for operational, security, payment, or analytical purposes.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-purple-500">Current Approved Processors</h2>
          <ul className="list-disc text-gray-700 space-y-2 pl-6">
            <li>Amazon Web Services (AWS) — Cloud infrastructure & server hosting</li>
            <li>Firebase / Google Cloud — Authentication, database & real-time services</li>
            <li>Stripe / PayPal / Wise — Payment processing & payouts</li>
            <li>Google Analytics — User traffic behavior analytics</li>
            <li>SendGrid / Mailchimp — Email communications</li>
            <li>Cloudflare — Global content delivery network & DDoS protection</li>
            <li>ReCaptcha — Bot & fraud prevention security tool</li>
            <li>OpenAI — AI-powered moderation & content processing (subject to strict filtering)</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-semibold text-purple-500">Data Protection Commitments</h2>
          <ul className="list-disc text-gray-700 space-y-2 pl-6">
            <li>All processors sign strict confidentiality and data processing agreements before onboarding.</li>
            <li>User data remains owned by the user — processors cannot repurpose data for external commercial gain.</li>
            <li>We audit all external services regularly to ensure full compliance with global privacy standards (GDPR, CCPA, UAE, etc.).</li>
          </ul>
        </div>

        <p className="text-gray-500 italic">
          M2T commits to full transparency. Our third-party processors are carefully chosen to balance platform functionality, security, and privacy for every verified financial market professional.
        </p>
      </div>
    </div>
  );
}
